import styled from 'styled-components';
import StatusComponent from './StatusComponent';
import IconHeart from '../../assets/icon/icon-heart-green.svg';

const DateSection = () => {
  const weeks = ['일', '월', '화', '수', '목', '금', '토'];
  const days = Array.from({ length: 30 }, (x, i) => i + 1);

  return (
    <StyledSection id="date">
      <h2 className="a11y-hidden">일정</h2>
      <StyledP>
        2025년 6월 1일
        <br />
        일요일 <strong>오전 11시</strong>에 만나요.
      </StyledP>
      <StyledCalendar>
        <h3>6월</h3>
        <StyledWeekUl>
          {weeks.map((day, index) => (
            <li key={index} className={day == '일' ? 'active' : ''}>
              {day}
            </li>
          ))}
        </StyledWeekUl>
        <StyledDayUl>
          {days.map((day, index) => (
            <li key={index} className={day == 1 ? 'active' : ''}>
              {day}
            </li>
          ))}
        </StyledDayUl>
      </StyledCalendar>
      <StatusComponent />
    </StyledSection>
  );
};

const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 4rem 3rem;
  background-color: var(--main-background);
`;

const StyledP = styled.p`
  font-size: 1.8rem;
  line-height: 2.4rem;
  text-align: center;

  & > strong {
    font-family: 'Eulyoo1945-Bold';
  }
`;

const StyledCalendar = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 3rem 2.6rem;
  background-color: var(--background);
  border-radius: 2rem;
  font-size: 1.8rem;
  line-height: 2rem;
  text-align: center;

  & > h3 {
    font-size: 2.4rem;
    line-height: 2.4rem;
    font-family: 'Eulyoo1945-Bold';
  }
`;

const StyledWeekUl = styled.ul`
  display: flex;
  gap: 2.5rem;

  & > li.active {
    font-family: 'Eulyoo1945-Bold';
  }
`;

const StyledDayUl = styled.ul`
  display: grid;
  grid-template-columns: repeat(7, 1.8rem);
  justify-content: center;
  gap: 1.5rem 2.5rem;

  & > li.active {
    position: relative;

    &::after {
      position: absolute;
      left: 50%;
      top: -0.5rem;
      transform: translateX(-50%);
      content: '1';
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      color: var(--background);
      width: 3rem;
      height: 3rem;
      background: url(${IconHeart}) center center/ cover no-repeat;
    }
  }
`;

export default DateSection;
